import { useEffect, useState } from "react";
import { whenFree } from "@/lib/popupQueue";
import { Ticket, PartyPopper, Check } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { confetti, playFanfare, playDrumroll, floatEmojis, playCoin } from "@/lib/celebrate";

const KEY = "itz_seen_scratch_big";
const seen = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const busy = () => document.querySelector('[role="dialog"],[data-testid="lucky-wheel-modal"],[data-testid="level-up-modal"],[data-testid="jackpot-celebration"],[data-testid="redeem-celebration"],[data-testid="duel-celebration"],[data-testid="duel-versus"],[data-testid="new-games-intro"]');

export function ScratchBigCelebration() {
  const { user } = useAuth();
  const [ev, setEv] = useState(null);
  const [sent, setSent] = useState(false);
  useEffect(() => {
    if (!user) return;
    const check = () => {
      if (document.visibilityState !== "visible" || busy()) return;
      api.get("/community/scratch-big-latest").then(({ data }) => {
        if (!data || seen().includes(data.id)) return;
        whenFree(`scratch-${data.id}`, () => {
          localStorage.setItem(KEY, JSON.stringify([...seen(), data.id].slice(-30)));
          setEv(data); setSent(false);
          playDrumroll(700);
          setTimeout(() => { playFanfare(); [0, 350, 700].forEach((d, i) => setTimeout(() => confetti({ x: innerWidth * (0.2 + 0.3 * i), y: innerHeight * 0.4, count: 90, spread: 1.6 }), d)); }, 700);
          setTimeout(() => setEv((c) => (c?.id === data.id && !c.hold ? null : c)), 9000);
        });
      }).catch(() => {});
    };
    const t = setTimeout(check, 10000);
    const iv = setInterval(check, 15000);
    return () => { clearTimeout(t); clearInterval(iv); };
  }, [user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!ev) return null;
  const congrats = (e) => {
    floatEmojis(e.currentTarget, "🎉", 10); playCoin(2); setSent(true); setEv((c) => ({ ...c, hold: true }));
    api.post(`/wheel/jackpot/${ev.id}/congrats`).catch(() => {}); setTimeout(() => setEv(null), 1600);
  };
  return (
    <div className="fixed inset-0 z-[88] flex items-center justify-center p-6 bg-amber-950/55 backdrop-blur-sm wheel-fade" data-testid="scratch-big-celebration" style={{ pointerEvents: "auto" }}>
      <div className="relative w-full max-w-sm text-center levelup-pop">
        <span className="burst-rays !-inset-24" aria-hidden />
        <p className="relative text-xs font-extrabold uppercase tracking-[0.35em] text-amber-200">Live in der Community</p>
        <div className="relative mx-auto mt-6 w-64 rounded-3xl border-4 border-amber-300 bg-gradient-to-br from-amber-200 via-yellow-100 to-pink-200 p-5 shadow-2xl shadow-amber-500/40 win-glow overflow-hidden">
          <span className="scratch-shine absolute inset-0" aria-hidden />
          <Ticket className="w-8 h-8 text-amber-600 mx-auto" />
          <p className="font-display text-6xl font-black text-rose-600 prize-pop" data-testid="scratch-big-prize">+{ev.prize}</p>
          <p className="text-sm font-extrabold text-amber-700">Punkte freigerubbelt!</p>
        </div>
        <div className="relative mt-5 flex items-center justify-center gap-3">
          {ev.picture ? <img src={ev.picture} alt={ev.name} className="w-11 h-11 rounded-full object-cover ring-4 ring-amber-200" />
            : <span className="w-11 h-11 rounded-full pink-gradient text-white font-extrabold flex items-center justify-center ring-4 ring-amber-200">{ev.name?.[0]?.toUpperCase()}</span>}
          <span className="font-display text-xl font-extrabold text-white" data-testid="scratch-big-name">{ev.name}</span>
        </div>
        <button type="button" disabled={sent} onClick={congrats} data-testid="scratch-big-congrats"
          className="relative mt-5 w-full h-12 rounded-full bg-gradient-to-r from-amber-300 to-orange-400 text-amber-950 font-extrabold inline-flex items-center justify-center gap-2 active:scale-95 transition-transform disabled:opacity-90">
          {sent ? <><Check className="w-5 h-5" /> Glückwunsch gesendet!</> : <><PartyPopper className="w-5 h-5" /> Gratulieren</>}
        </button>
        <button type="button" onClick={() => setEv(null)} data-testid="scratch-big-close" className="relative mt-2 w-full py-2 text-sm font-bold text-white/80">Mega! 🎉</button>
      </div>
    </div>
  );
}
